// Add a Passkey's password prompt (Andrew, 2026-10-31, decisions register G-X22: a; ledger L1077): adding a passkey
// needs a step-up within the last five minutes, so when the server answers `step_up_required` the person confirms their
// password first. Commander's step-up words and controls (alert-dialog.tsx): a Password field with Show/Hide, and
// "Re-authentication failed" when it is refused. Legacy has no passkeys, so there is no legacy screen to match.
import { useState } from 'react';
import { Button, Dialog, TextField } from '@radish/ui-web';

/** A refused step-up (Commander's words, staff-sign-in.ts). */
export const STEP_UP_FAILED = 'Re-authentication failed';

export function PasskeyStepUpDialog({ onConfirm, onClose }: {
  /** Steps up with the password; null when it worked, else the words to show. */
  readonly onConfirm: (password: string) => Promise<string | null>;
  readonly onClose: () => void;
}) {
  const [password, setPassword] = useState('');
  const [shown, setShown] = useState(false);
  const [failed, setFailed] = useState<string | null>(null);
  const [checking, setChecking] = useState(false);
  const confirm = async () => {
    setChecking(true);
    const refused = await onConfirm(password);
    setChecking(false);
    if (refused !== null) setFailed(refused);
  };
  const footer = (
    <>
      <Button variant="outline" onClick={onClose}>Close</Button>
      <Button onClick={() => void confirm()} disabled={password === '' || checking}>Continue</Button>
    </>
  );
  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose(); }} title="Add a Passkey" testId="passkey-step-up" footer={footer}>
      <div className="flex flex-col gap-3">
        <p className="text-[14px]">Confirm your password to add a passkey.</p>
        <TextField
          label="Password" type={shown ? 'text' : 'password'} value={password} onValueChange={(v) => { setPassword(v); setFailed(null); }} autoComplete="current-password"
          append={<button type="button" className="text-[13px] text-primary" onClick={() => setShown((s) => !s)}>{shown ? 'Hide' : 'Show'}</button>}
        />
        {failed === null ? null : <p role="alert" className="text-[14px] text-negative">{failed}</p>}
      </div>
    </Dialog>
  );
}
